import { render, staticRenderFns } from "./TabelaDeSubitens.vue?vue&type=template&id=99b1ed0e&scoped=true"
import script from "./TabelaDeSubitens.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeSubitens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeSubitens.vue?vue&type=style&index=0&id=99b1ed0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b1ed0e",
  null
  
)

export default component.exports